import { useEffect, useState } from "react";
import GradientBg from "@/components/common/GradientBg";
import api from "@/lib/api";
import { BRAND } from "@/branding.config";

const STATUS_STYLES = {
  operational: "bg-emerald-500/10 text-emerald-500 border-emerald-500/25",
  degraded:    "bg-amber-500/10 text-amber-500 border-amber-500/25",
  outage:      "bg-red-500/10 text-red-500 border-red-500/25",
};

export default function Status() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/public/status").then((r) => setData(r.data));
  }, []);

  return (
    <div className="relative">
      <GradientBg variant="soft" />
      <section className="relative mx-auto max-w-4xl px-6 pt-24 pb-24">
        <div className="text-xs uppercase tracking-[0.2em] text-primary font-bold">Status</div>
        <h1 className="mt-3 text-5xl md:text-6xl font-black tracking-tight">Platform status</h1>
        <p className="mt-4 text-muted-foreground">
          Live health of every {BRAND.app_name} service. Incident history is published for every event lasting over 60 seconds.
        </p>

        {data && (
          <div className="mt-10">
            <div className={`glass rounded-2xl p-6 border ${data.overall === "operational" ? "border-emerald-500/25" : "border-amber-500/25"}`}>
              <div className="flex items-center gap-3">
                <span className={`h-3 w-3 rounded-full ${data.overall === "operational" ? "bg-emerald-500 animate-pulse" : "bg-amber-500"}`} />
                <span className="text-lg font-bold">All systems operational</span>
              </div>
              <div className="mt-1 text-xs text-muted-foreground font-mono">
                Last checked {new Date(data.checked_at).toLocaleString()}
              </div>
            </div>

            <div className="mt-6 space-y-2">
              {data.services.map((s) => (
                <div key={s.name} className="surface px-5 py-4 flex items-center justify-between">
                  <div className="font-semibold">{s.name}</div>
                  <div className="flex items-center gap-4">
                    <div className="text-xs font-mono text-muted-foreground">
                      {s.uptime_30d}% <span className="text-muted-foreground/60">30d</span>
                    </div>
                    <span className={`text-[11px] px-2.5 py-0.5 rounded-full border ${STATUS_STYLES[s.status] || STATUS_STYLES.operational}`}>
                      {s.status}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </section>
    </div>
  );
}
